export default __webpack_public_path__ + "static/media/8t.cd2f0fd2.jpg";